import React from 'react';
import LeaveManagement from './leaves/LeaveManagement';

const Leaves: React.FC = () => {
  return <LeaveManagement />;
};

export default Leaves;